import React from "react";

interface FormInputProps {
  label: string;
  name: string;
  placeholder: string;
  error?: any;
  register: any;
  type?: string;
  className?: string;
  icon?: React.ReactNode;
  required?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  placeholder,
  error,
  register,
  type = "text",
  className = "",
  icon,
  required = true,
}) => (
  <div>
    <label className="block font-medium mb-1">
      {label} {required && <span className="text-[#0033CC]">*</span>}
    </label>
    <div className="relative">
      {icon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          {icon}
        </span>
      )}
      <input
        {...register(name)}
        type={type}
        className={`w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-gray-300 ${
          error ? "border-red-500" : ""
        } ${icon ? "pl-10" : ""} ${className}`}
        placeholder={placeholder}
      />
    </div>
    {error && <span className="text-red-500 text-xs">{error.message}</span>}
  </div>
);

export default FormInput;
